if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}

Element.prototype.remove = function () {
  try {
    this.parentElement.removeChild(this);
  } catch { }
}

import cssVars from 'css-vars-ponyfill';
cssVars();

import Vue from "vue";
import App from "./App.vue";

import Vuesax from "vuesax";
import "material-icons/iconfont/material-icons.css";
import "vuesax/dist/vuesax.css";
Vue.use(Vuesax);

import VueCookies from "vue-cookies";
VueCookies.config("7d");

Vue.use(VueCookies);

import axios from "axios";
Vue.prototype.$http = axios;

import "../themeConfig.js";

import AuthPlugin from "./plugins/auth";
//import SignalRPlugin from "./plugins/signalr";
import MiscPlugin from "./plugins/misc";
Vue.use(AuthPlugin);
//Vue.use(SignalRPlugin);
Vue.use(MiscPlugin);

import { VueReCaptcha } from "vue-recaptcha-v3";
Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

import "./globalComponents.js";

import "./assets/scss/main.scss";
import "@/assets/css/main.css";

import router from "./router";
import store from "./store/store";
import i18n from "./i18n/i18n";
import "./filters/filters";

import { extend, configure } from "vee-validate";
import { confirmed, length, numeric, digits, required, email, min, max, min_value } from "vee-validate/dist/rules";

configure({
  defaultMessage: (field, values) => {
    return i18n.t(`validation.${values._rule_}`, values);
  }
});

var currencyGlobalOptions = {
  globalOptions: {
    "distraction-free": "hideCurrencySymbol",
    currency: {
      prefix: "₺ "
    },
    locale: "tr-TR",
  }
};

extend("confirmed", confirmed);
extend("numeric", numeric);
extend("digits", digits);
extend("required", required);
extend("email", email);
extend("min", min);
extend("max", max);
extend("length", length);
extend("min_value", min_value);

extend('uppercase', {
  validate: value => value.match(/[A-Z]/g) !== null
})

extend('anynumber', {
  validate: value => value.match(/[0-9]/g) !== null
})

extend('strongpassword', {
  validate: value => {
    var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{8,})");
    return strongRegex.test(value);
  }
})


extend('no_tr', {
  validate: value => {
    var strongRegex = new RegExp("^(?!.*[çÇğĞıİöÖşŞüÜ])");

    return strongRegex.test(value);
  }
})


extend("required_c", {
  validate: function (value, args) {
    return value == true ? true : false;
  }
});

extend("gender", {
  validate: function (value, args) {
    return value > 0;
  }
});

extend("identityNumber", {
  validate: function (value, args) {
    var regex, regex_p, v;
    v = value.replace(/\s+/g, "").toUpperCase();

    regex = /^[1-9]{1}[0-9]{10}$/;

    return v.match(regex) != null;
  }
});

import { VueHammer } from "vue2-hammer";
Vue.use(VueHammer);

import "prismjs";
import "prismjs/themes/prism-tomorrow.css";

require("./assets/css/iconfont.css");

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount("#app");
